// extracted by mini-css-extract-plugin
module.exports = {"createdOnWebBanner":"IsWebCreatedBanner_createdOnWebBanner__2WaxN"};